import React from "react";
import themePropTypes from "../theme-prop-types";
import { PAYMENT_BUTTON_PROPS } from "../../utils/constants";

const Button = ({
  label,
  ariaLabel,
  onClick,
  className,
  name,
  data,
  text = "",
  disabled,
  lastOfKind,
  onlyOfKind,
  isLoading = false
}) => {
  const background = data?.background ? data.background : "none";

  return (
    <button
      style={{ backgroundColor: background }}
      name={name}
      data-testid={`button-${name}${
        text ? `-${text.replace(/(\r\n|\n|\r| )/gm, "")}` : ""
      }`}
      className={`button-web-sdk ${lastOfKind ? "last-of-kind" : ""} ${
        onlyOfKind ? "only-of-kind" : ""
      } ${disabled ? "disabled" : ""} ${className || ""} button-${name} ${
        isLoading ? "is-loading" : ""
      }`}
      type='button'
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {name === PAYMENT_BUTTON_PROPS.name ? (
        <span className='button-web-sdk-label'>{label}</span>
      ) : (
        label
      )}
    </button>
  );
};

Button.propTypes = themePropTypes.button;

export default Button;
